
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AdListItemPrice',
  props: {
    ad: {
      type: Object,
      required: true,
    },
    showPriceSquare: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isEstateAgency() {
      return this.ad.estateAgencyId;
    },
    priceClass(): string {
      if (this.ad.estateType === 100) return 'price-apartment';
      else if (this.ad.estateType === 200) return 'price-house';
      else if (this.ad.estateType === 300) return 'price-land';
      else if (this.ad.estateType === 400) {
        if (this.ad.estateSubType === 401) return 'price-parking';
        return 'price-object';
      }
      return '';
    },
    isSale(): boolean {
      return this.ad.adType === 1;
    },
    isLease(): boolean {
      return this.ad.adType === 2;
    },
    isRoommate(): boolean {
      return this.ad.adType === 3;
    },
    isDeveloperProject(): boolean {
      return this.ad.estateType === 500;
    },
  },
});
